<template>
  <div style="background: #f2f2f6; height: 100%">
         <el-row></el-row>
         <el-descriptions style="padding:10px" :column="4" size="mini" border>
    <el-descriptions-item >
      <template slot="label">
        {{$t('device.yesterdayPowerused')}}
      </template>
        <span style="font-size:14x">{{power.length>=2?power[1].powerused:0 }}{{heatpump.protocolid==605?'m³':'kw·h'}}</span>
    </el-descriptions-item>
    <el-descriptions-item >
      <template slot="label">
        {{$t('device.todayPowerused')}}
      </template>
        <span style="font-size:14x">{{ power.length>=1?power[0].powerused:0 }}{{heatpump.protocolid==605?'m³':'kw·h'}}</span>
    </el-descriptions-item>
    <el-descriptions-item >
      <template slot="label">
        {{$t('device.currentA')}}
      </template>
        <span style="font-size:14x">{{heatpump.elecrt||'-'}}A</span>
    </el-descriptions-item>
    <el-descriptions-item >
      <template slot="label">
        {{$t('device.currentW')}}
      </template>
        <span style="font-size:14x">{{heatpump.totalpower||'-'}}KW</span>
    </el-descriptions-item>
  </el-descriptions>
        <el-table
          :data="power"
          ref="table"
          stripe
          border
          style="width: 100%; border-radius: 0 0 10px 10px;font-size:12px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
        <template slot="empty">
                 <div>{{$t('device.noAcbData')}}
              </div>
             </template>
             <el-table-column
            type="index"
            width="75">
          </el-table-column>
             <el-table-column prop="createdtime" :label="$t('base.date')" >
               </el-table-column>
               <el-table-column prop="powerused" :label="$t('device.powerused')" >
                <template slot-scope="scope">
        <span>{{scope.row.powerused}}{{heatpump.protocolid==605?'m³':'kw·h'}}</span>
        </template>
               </el-table-column>
        </el-table>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'acb',
  data () {
    return {
      power: []
    }
  },
  computed: {
    heatpump () {
      let acb = this.$store.state.devicelist.filter(d => { return d.type === 'acb' })
      if (acb && acb.length > 0) {
        return acb[0]
      } else {
        let heat = this.$store.state.devicelist.filter(d => { return d.type === 'heatpump' && d.subdevs === 1 })
        if (heat && heat.length > 0) {
          return heat[0]
        } else {
          return {}
        }
      }
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      setTimeout(() => {
        Vue.axios.post('/report/power/query', {deviceid: self.heatpump.innerid}).then((res) => {
          if (res.data.errcode == 0) {
            self.power = res.data.msgbody
          }
        })
      }, 1000)
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Devices/Acb.vue